var map = {
	"./add.svg": "b3c0",
	"./badge-level-1.svg": "1293",
	"./badge-level-2.svg": "d733",
	"./badge-level-3.svg": "4ed5",
	"./badge-level-4.svg": "ab10",
	"./badge-level-5.svg": "2be6",
	"./bold.svg": "d053",
	"./chat.svg": "2066",
	"./check.svg": "4a24",
	"./checkbox.svg": "eca4",
	"./chevron-down.svg": "fc34",
	"./chevron-left.svg": "2383",
	"./chevron-right.svg": "f0c2",
	"./circle-check.svg": "be8d",
	"./clock.svg": "3175",
	"./close.svg": "bb7c",
	"./cloud.svg": "da37",
	"./dashboard.svg": "6f9f",
	"./dots.svg": "aea1",
	"./facebook.svg": "7e4b",
	"./file-text.svg": "54ee",
	"./gears.svg": "b92f",
	"./illustration-1.svg": "1c1d",
	"./illustration-2.svg": "afd0",
	"./illustration-3.svg": "6b2f",
	"./italic.svg": "aa11",
	"./lock.svg": "3b18",
	"./logo-small.svg": "4850",
	"./logo.svg": "a5f7",
	"./lungs.svg": "a117",
	"./mail.svg": "4f1b",
	"./meter.svg": "3cb7",
	"./news.svg": "4ee0",
	"./ol.svg": "069c",
	"./paragraph.svg": "db03",
	"./phasing-out-plan.svg": "b396",
	"./questions.svg": "dbd7",
	"./quote.svg": "deae",
	"./smoke.svg": "50c1",
	"./sort.svg": "08f0",
	"./spyglass.svg": "71f2",
	"./strike.svg": "a65b",
	"./subtract.svg": "0dbc",
	"./timeline.svg": "8b56",
	"./trash.svg": "9961",
	"./twitter.svg": "5a0b",
	"./ul.svg": "9218",
	"./underline.svg": "63ec",
	"./user-bell.svg": "04b5",
	"./user-circle-check.svg": "0832",
	"./user-info.svg": "9d68",
	"./user-key.svg": "3f6f",
	"./user-log-out.svg": "7951",
	"./user-mail.svg": "7eb4",
	"./user-refresh-ccw.svg": "8fcc",
	"./user-user-circle.svg": "8cd6",
	"./valuta.svg": "58d8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfd9";